import React from 'react';

export function ProjectDocsRecent() {
  const recentDocs = [
    {
      id: '1',
      name: 'Quyết định phê duyệt dự án.pdf',
      user: 'Nguyễn Văn An',
      time: '15/05/2024 09:30',
      icon: 'ri-file-pdf-2-fill',
      color: 'text-rose-500'
    },
    {
      id: '2',
      name: 'Ảnh hiện trường 15_05_2024.jpg',
      user: 'Phạm Văn Tài',
      time: '15/05/2024 09:10',
      icon: 'ri-image-fill',
      color: 'text-amber-500'
    },
    {
      id: '3',
      name: 'Báo cáo tiến độ tháng 4.docx',
      user: 'Lê Hoàng Nam',
      time: '14/05/2024 16:45',
      icon: 'ri-file-word-fill',
      color: 'text-blue-500'
    }
  ];

  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Hoạt động gần đây</h3>
        <button className="text-xs font-normal text-emerald-600 hover:underline">Tất cả</button>
      </div>

      <div className="space-y-4">
        {recentDocs.map((doc) => (
          <div key={doc.id} className="flex gap-3 group cursor-pointer">
             <div className="w-8 h-8 rounded-md bg-slate-50 flex items-center justify-center shrink-0 group-hover:bg-slate-100 transition-colors">
                <i className={`${doc.icon} ${doc.color} text-lg`} />
             </div>
             <div className="space-y-0.5 min-w-0">
                <h4 className="text-xs font-normal text-slate-700 truncate group-hover:text-emerald-600 transition-colors">{doc.name}</h4>
                <div className="flex justify-between items-center text-xs font-normal text-slate-400">
                   <span>{doc.user}</span>
                   <span>{doc.time}</span>
                </div>
             </div>
          </div>
        ))}
      </div>
    </div>
  );
}
